import script from "./ImageClipHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageClipHandler.vue?vue&type=script&lang=ts&setup=true"

import "./ImageClipHandler.vue?vue&type=style&index=0&id=5984406b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5984406b"]])

export default __exports__